export const GET_ALL_VENDOR_CATEGORY = 'GET_ALL_VENDOR_CATEGORY'
export const GET_ALL_VENDOR_CATEGORY_SUCCESS = 'GET_ALL_VENDOR_CATEGORY_SUCCESS'


export const GET_ALL_SUB_CATEGORY = 'GET_ALL_SUB_CATEGORY'
export const GET_ALL_SUB_CATEGORY_SUCCESS = 'GET_ALL_SUB_CATEGORY_SUCCESS'